// Joins the elements of the array with commas except the last element which
// is joined using the given conjunction (default: "and")
export function readableJoinStringArray(
  strs: Array<string>,
  conjunction = 'and',
): string {
  if (!strs || !strs.length) {
    return '';
  }
  switch (strs.length) {
    case 1:
      return strs[0] as string;
    case 2:
      return strs.join(` ${conjunction} `);
    default:
      return `${strs.slice(0, strs.length - 1).join(', ')} ${conjunction} ${
        strs[strs.length - 1]
      }`;
  }
}
